module.exports = __webpack_public_path__ + "static/media/xml.b3cd7f55.png";